var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:(_vm.onintersect),expression:"onintersect"}],staticClass:"intersection_wrapper",style:(_vm.min_height?`min-height: ${_vm.min_height}`:'')},[(_vm.show || _vm.show_always)?_vm._t("default",null,{"show":_vm.show}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }